export const coverStyle = {
    textAlign: 'center',
    // borderBottom: '1px solid #888',
}

export const imgStyle = {
    width: 300,
}

export const cardImgMargin = 10;

export const cardStyle = {
    width: imgStyle.width + cardImgMargin*2,
    marginBottom: 10,
};

export const masonryStyle = {
    paddingTop: 10,
    paddingBottom: 10,
}

export const masonryOptions = {
    gutter: 10,
    // percentPosition: true,
    fitWidth: true,
}

export const iconTheme = 'outlined'; // 'twoTone'
